import api from "./axiosInstance";

// GET /dashboard/usageTrends?start=&end=&interval=&metric=
export async function getUsageTrends(params) {
	const {
		start,
		end,
		interval = "day",
		metric = "visits"
	} = params || {};
	const { data } = await api.get("/dashboard/usageTrends", {
		params: { start, end, interval, metric }
	});
	return data;
}


